import { Box } from '@mui/material';
import TermsAndConditionsPDF from '../components/Layout/TermsAndConditionsPage/TermsAndConditions.pdf';


function TermsAndConditions() {
    window.open(TermsAndConditionsPDF, '_blank');
    window.location.replace('/');

    return (
      <Box>
        Opening Terms and Conditions PDF in a new tab...
      </Box>
    )
}

export default TermsAndConditions